import App from '../app'
import Vue from 'vue'
import VCardAverageAgeDetail from '../../vue/components/VCardAverageAgeDetail.vue'
import VCardAverageExecutionsDetail from '../../vue/components/VCardAverageExecutionsDetail.vue'
import VCardTop3BiggestDetail from '../../vue/components/VCardTop3BiggestDetail.vue'
import VCardTop3LowestDetail from '../../vue/components/VCardTop3LowestDetail.vue'
import VCardTotalEnforcedDetail from '../../vue/components/VCardTotalEnforcedDetail.vue'
import VCardTotalExecutionsDetail from '../../vue/components/VCardTotalExecutionsDetail.vue'
import VCardTotalSubjectsDetail from '../../vue/components/VCardTotalSubjectsDetail.vue'

new Vue({
  extends: App,
  components: {
    VCardAverageAgeDetail,
    VCardAverageExecutionsDetail,
    VCardTop3BiggestDetail,
    VCardTop3LowestDetail,
    VCardTotalEnforcedDetail,
    VCardTotalExecutionsDetail,
    VCardTotalSubjectsDetail
  }
})
